import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { Plan, PLAN_COLUMNS, PlanSection, SECTION_COLUMNS } from '../lib/plans';

/**
 * Every plan row the caller may read: public plans for anyone, plus hidden legacy plans
 * for a signed-in user (RLS decides), and the plan-page sections. Loaded once per mount.
 * Sections are best-effort: a failure there never hides the plans.
 */
export const usePlans = () => {
  const [plans, setPlans] = useState<Plan[]>([]);
  const [sections, setSections] = useState<PlanSection[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const [planRes, sectionRes] = await Promise.all([
        (supabase as any).from('subscription_plans').select(PLAN_COLUMNS),
        (supabase as any).from('subscription_plan_sections').select(SECTION_COLUMNS),
      ]);
      if (cancelled) return;
      if (planRes.error) {
        console.error('Failed to load plans:', planRes.error);
        setError(planRes.error.message || 'Could not load plans');
      }
      if (sectionRes.error) console.error('Failed to load plan sections:', sectionRes.error);
      setPlans((planRes.data as Plan[]) || []);
      setSections((sectionRes.data as PlanSection[]) || []);
      setLoading(false);
    })();
    return () => { cancelled = true; };
  }, []);

  return { plans, sections, loading, error };
};
